var $ = jQuery;
var isMobilePlatform = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
var isHttps = location.protocol === 'https:'

$.fn.setCursorPosition = function(pos) {
	if ($(this).get(0).setSelectionRange) {
		$(this).get(0).setSelectionRange(pos, pos);
	} else if ($(this).get(0).createTextRange) {
		var range = $(this).get(0).createTextRange();
		range.collapse(true);
		range.moveEnd('character', pos);
		range.moveStart('character', pos);
		range.select();
	}
};

$(function () {
	indexSlider();
	ajaxModals();
	calculator();
	bvi();
	meetingTitle();
	prettyMonth();
	paymentsTooltips();
	changeFields();
	citySelector();
    closeBanner();
    showBanner();
	getCookie();
	deleteAllCookies();
	showTouchDocs();
});

$(window).on({
	load: function () {
		deleteAllCookies()
	}
})

$(window).on({
	message: function (event) {
		if(event.originalEvent.data === 'failFinal') {
			$('.tkb-wrapper').removeClass('d-none')
			$('.processing-form').addClass('d-none')
			$('.payment_state').removeClass('d-none')
			$('.notice__element').removeClass('d-none')
			$('.js-payment-state-fail').removeClass('d-none')
		}

		if(event.originalEvent.data === 'final') {
			$('.tkb-wrapper').removeClass('d-none')
			$('.processing-form').addClass('d-none')
			$('.payment_state').removeClass('d-none')
			$('.notice__element').removeClass('d-none')
			$('.js-payment-state-success').removeClass('d-none')
		}
	}
})

$('#pay_frame').on('load', function () {
	$('#pay_frame a.js-cleanup_link').removeClass('d-none')
	let status = window.frames.pay?.location?.pathname
	const is_response = status === '/payment-success/' || status === '/payment-fail/'
	if(is_response && isMobilePlatform) {
		$('.processing-form').css('paddingTop', '260px')
		$(this).css(
			{
				'position': 'absolute',
				'bottom': '-86px'
			}
		)
	}
})


$('input[name="sum"]').on({
	input: function () {
		if($(this).val().length > 0) {
			$(this).removeClass('input-error')
			$(`label[for="${$(this).attr('id')}"]`).hide()
		}
	}
})

function indexSlider() {
	const swiper = new Swiper('.index-slider', {
		speed: 400,
		spaceBetween: 100,
		slidesPerView: 1,
		simulateTouch: false,
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		}
	});
}

function bvi() {
	new isvek.Bvi({
		target: '.bvi-open',
		theme: 'white'
	});
}

function showSuccessModal() {
	const success = new bootstrap.Modal(document.querySelector('#successModal'),  {
		backdrop: true,
		keyboard: true,
		focus: true
	})
	success.show()
}

function successContractVerify () {
	const cookies = getCookie()
	if(cookies.error !== undefined) {
		$('#js-overlay').removeClass('d-none')
		$('.fail').removeClass('d-none')
		$('.fail > .notice__content > .notice__text').text(`${decodeURIComponent(cookies.error)}!`)
	}

	if(cookies.error === undefined && cookies.total_balance <= 0) {
		$('#overlay').removeClass('d-none')
		$('.no-debt').removeClass('d-none')
		$('.no-debt >  .notice__content > .notice__title span').text(`${decodeURIComponent(cookies.contract_num)}`)
	}

	if(cookies.error === undefined && cookies.total_balance === undefined) {
		$('#overlay').removeClass('d-none')
		$('.fail').removeClass('d-none')
		$('.fail > .notice__content > .notice__title').text(`Ошибка получения данных по договору ${decodeURIComponent(cookies.contract_num)}`)
		$('.fail > .notice__content > .notice__text').text('Попробуйте позже')
	}

	if(cookies.error === undefined && cookies.state !== 'signed_issued') {
		$('#overlay').removeClass('d-none')
		$('.fail').removeClass('d-none')
		$('.fail > .notice__content > .notice__title').text('Договор не найден')
	}

	if(cookies.error === undefined
		&& cookies.state === 'signed_issued'
		&& cookies.client_hash !== undefined
		&& cookies.client_hash.length > 0
		&& cookies.total_balance > 0
		&& cookies.total_balance !== undefined
	) {
		$('#overlay').addClass('d-none')
		$('.notice').addClass('d-none')

		$('.contract_verify_page').addClass('d-none')
		$('.contract_payment-page').removeClass('d-none')

		$('#js-contract-num').text(`Оплата договора №${decodeURIComponent(cookies.contract_num)}`)
		$('#js-pay-today-sum').text(`${cookies.total_today_sum} ₽`)
		$('#js-pay-today button').text(`${cookies.total_today_sum} руб.`)
		$('#js-pay-full button').text(`${cookies.total_balance} руб.`)
		$('#cp-sum').val(cookies.total_today_sum)

		if(cookies.sbp !== '1') {
			$('#js-pay-sbp-btn').attr('disabled', true)
			$('#js-pay-sbp-comission-alert').text('Согласно тарифам вашего банка, при оплате банковской картой может взиматься комиссия.')
		} else {
			$('#js-pay-sbp-btn').removeAttr('disabled')
			$('#js-pay-sbp-comission-alert').text('Согласно тарифам вашего банка, при оплате банковской картой может взиматься комиссия, при оплате через СБП – комиссия не взимается')
		}

		if(cookies.company_name !== null) {
			if(decodeURIComponent(cookies.company_name).match(/гиллион/i)) {
				$('.js-gillion-req').removeClass('d-none')
			}

			if(decodeURIComponent(cookies.company_name).match(/тачфинанс/i)) {
				$('.js-touch-req').removeClass('d-none')
			}
		}
	}
}

function successPaymentRequest() {
	const cookies = getCookie()

	if(cookies.error_payment !== undefined) {
		$('#overlay').removeClass('d-none')
		$('.fail').removeClass('d-none')
		$('.payment_request').addClass('d-none')
		$('.fail > .notice__content > .notice__title').text(`${decodeURIComponent(cookies.error_payment)}!`)
	}

	if(cookies.error_payment === undefined) {
		const link = decodeURIComponent(cookies.payment_link)
		$('.contract_payment-page').addClass('d-none')
		$('.processing-form').removeClass('d-none')
		$('#pay_frame').attr('src', link)
		$('#overlay').addClass('d-none')
		$('.notice').addClass('d-none')
	}
}

function getTimezone(form) {
	const date = new Date().toString()
	let concatDate = dayjs().format('DD.MM.YYYY HH:mm:ss').concat(` ${date.slice(date.indexOf('G'))}`)
	$(`#${form}_timezone`).attr('value', concatDate)
}

function sendAjaxForm(ajax_form, url, type="POST", withoutForm = false, queryParams = null) {
	$.ajax({
		url: url,
		type: type,
		dataType: "html",
		data: withoutForm === false ? $("#" + ajax_form).serialize() : queryParams,
		success: function() {
			switch (ajax_form) {
				case 'contract-verify-form':
					successContractVerify()
					break
				case 'contract-payment-form':
					successPaymentRequest()
					break
				default: showSuccessModal()
			}
			$(`#${ajax_form}`)[0].reset();
		}
	});
	return false;
}

function ajaxModals() {
	let calc = null
	if (document.querySelector('#calculation') !== null) {
		calc = new bootstrap.Modal(document.querySelector('#calculation'))
	}

	$('button[type="submit"]').on({
		click: function () {
			let $form = $(this).attr('form')
			getTimezone($form)
			if($(this).attr('id') === 'call_request_form_btn') {
				sendAjaxForm('call_request_form', `${ajaxData.url}?action=form`)
				Actions.hideModal('feedback')
				return false
			}

			if($(this).attr('id') === 'calc_form_btn') {
				sendAjaxForm('calc_form', '/wp-admin/admin-ajax.php?action=form')
				calc.hide()
				return false
			}

			if($(this).attr('id') === 'main_form_btn') {
				sendAjaxForm('main_form', `${ajaxData.url}?action=form`)
				return false
			}
		}
	})
}

function calculator() {
	/**
	 *
	 * @param sum Сумма
	 * @param i Процентная ставка (в день)
	 * @param n Количество платежей
	 * @returns {number}
	 */
	function calculate(sum, i, n) {
		const i_year = (i * 365) / 12;

		const percent = 1/100*i_year;
		const q = Math.pow((1 + percent), n);

		return Math.round(sum * (percent*q)/(q-1));
	}
	let $timeCalcResult = $('.js-calc-time-result');
	let $moneyCalcResult = $('.js-calc-money-result');
	let $calcDate = $('.js-calc-date');
	let $calcResult = $('.js-calc-result');
	let timeCalc = document.getElementById('calcTime');
	let moneyCalc = document.getElementById('calcMoney');

	if(!moneyCalc) return;

	function updateResult() {

		if(!moneyCalc.noUiSlider || !timeCalc.noUiSlider) return;

		let sum = parseInt(moneyCalc.noUiSlider.get());
		let time = parseInt(timeCalc.noUiSlider.get());

		$timeCalcResult.text(time);
		$moneyCalcResult.text(sum.toLocaleString());

		$calcResult.text(calculate(sum, calcInfo.percent, time).toLocaleString());

		let currentDate = new Date();
		let resultDate = new Date(currentDate.setMonth(currentDate.getMonth()+time)).toLocaleString('ru', {
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		});
		resultDate = resultDate.substring(0, resultDate.length - 3);
		$calcDate.text(resultDate);
	}


	noUiSlider.create(moneyCalc, {
		start: calcInfo.defaultSum,
		range: {
			'min': [calcInfo.minSum],
			'max': [calcInfo.maxSum]
		},
		step: 1000,
		connect: [true, false]
	});
	moneyCalc.noUiSlider.on('update', function (values, handle) {
		updateResult();
	});



	noUiSlider.create(timeCalc, {
		start: calcInfo.defaultTime,
		range: {
			'min': [calcInfo.minTime],
			'max': [calcInfo.maxTime]
		},
		step: 1,
		connect: [true, false]
	});
	timeCalc.noUiSlider.on('update', function (values, handle) {
		updateResult();
	});

	$('.js-calc-show-form').on('click', function () {
		$('.calculator__first').hide();
		$('.calculator__form').fadeIn();
	});

	$('.js-calc-prev').on('click', function () {
		$('.calculator__first').fadeIn();
		$('.calculator__form').hide();
	});

	$('.js-form-calc').on('submit', function (e) {
		e.preventDefault();

		$.ajax({
			url: $(this).attr('action'),
			method: 'POST',
			data: $(this).serialize(),
			success: function () {
				$('.calculator__form').hide();
				$('.calculator__success').css('display', 'flex').fadeIn();
			}
		});

	});
}

function meetingTitle() {
	let currentDate = new Date()
	$('#meeting_date').append(' (не позднее ' + `${new Date(currentDate.setDate(currentDate.getDate() + 3)).toLocaleDateString()})`)
}

function prettyMonth(){
	const setMonthState = () => {
		const $month_value = Number($('.js-calc-time-result').text())
		if($month_value === 1) {
			$('#month').html('&nbsp;месяц')
		} else if ($month_value < 5) {
			$('#month').html('&nbsp;месяца')
		} else {
			$('#month').html('&nbsp;месяцев')
		}
	}

	if(isMobilePlatform) {
		$('.noUi-touch-area').on( {
			touchmove: function () {
				setMonthState()
			}
		})
	} else {
		$('.noUi-touch-area').on( {
			mousemove: function () {
				setMonthState()
			}
		})
	}
}

function paymentsTooltips() {
	const el = {
		koronapay: $('.payment:nth-of-type(3) > ul')
	}
	if($(window).width() > 767) {
		$('.payment').on({
			mouseenter: function () {
				$(this).children('ul').show()
			},
			mouseleave: function (e) {
				if(e.pageY < 2734) {
					$(this).children('ul').hide()
				}
			}
		})

		$('#main-payments, .payment:nth-of-type(3) > ul').on({
			mouseleave: function () {
				$(this).hide()
			}
		})
	} else {
		$('.payment:nth-of-type(2)').on('click', function () {
			let $koronapay = $('.payment:nth-of-type(3) > ul')
			if($koronapay.css('display') === 'block') {
				$koronapay.hide()
			}
			$(this).children('#main-payments').toggle()
		})

		$('.payment:nth-of-type(3)').on('click', function () {
			let $mainpay = $('#main-payments')
			if($mainpay.css('display') === 'block') {
				$mainpay.hide()
			}
			$(this).children('.payment:nth-of-type(3) > ul').toggle()
		})
	}
}

function changeFields() {
	$("#agent-btn").on('click', function () {
		$('.cities').css('display', 'block')
		$('#feedback .modal-title').text('Заявка в офис')
		$('#inputDateFooter').attr('placeholder', 'Дата встречи')
		$('#inputTimeFooter').attr('placeholder', 'Время встречи')
		$('#agent_request').val('isForAgent')
		$('#call_request_form_formname').val('агент')
	})
	$("#feedback-btn").on('click', function () {
		Actions.showModal('feedback')
		$('.cities').css('display', 'none')
		$('#feedback .modal-title').html('Необходима консультация?<br>Мы вам перезвоним')
	})
	$("#need-callback").on('click', function () {
		$('.cities').css('display', 'none')
		$('#feedback .modal-title').html('Необходима консультация?<br>Мы вам перезвоним')
	})
}

function citySelector() {
	if (typeof cts === 'undefined') {
		return
	}
	const cities = cts.map(i => i.city)

	const list = cities.sort().map((value) => `<li class="cities-item">${value}</li>`)

	list.forEach(value => {
		$('.cities > ul').append(value)
	})

	$('.select-header').on('click', function () {
		$(this).toggleClass('open-list')
		$('.cities-list').toggle()
	})

	$('.cities-item').click(function () {
		let city = $(this).text()

		let guid = cts.filter(i => i.city === city)[0].guid;

		$('input[name="city-selected"]').val(city).addClass('selected')
		$('input[name="guid"]').val(guid)
		$(this).toggleClass('selected')
		$(this).siblings('.cities-item').removeClass('selected')

		$('.cities-list').hide()
	})
}

function closeBanner() {
    $('#banner button.banner-close').on('click', function () {
        $('#overlay, #banner').hide()
    })
}

function showBanner() {
    $(window).on('load', function () {
        $('#overlay, #banner').show();
    })
}


// Работа с cookies

// Очистка cookies при отмене оплаты (IIFE)
(function cleanPaymentData() {
	$('a.js-cleanup_link').on('click', function () {
		$('.processing-form').addClass('d-none')
		$('.contract_verify_page').removeClass('d-none')
		$('.contract_payment-page').addClass('d-none')
		$('#pay_frame').hide()
		deleteAllCookies()
	})
})()

function getCookie() {
	const cookiesToArray = document.cookie.split('; ')
	return cookiesToArray.reduce((acc, item) => {
		const [name, value] = item.split('=')
		acc[name] = value
		return acc
	}, {})
}

function deleteCookies(cookies) {
	cookies.forEach((item) => {
		document.cookie = item + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
	})
}

function deleteAllCookies() {
	// TODO: Костыль до момента реализации быстрой оплаты через БД
	let cookie_policy = null
	if(getCookie()['cookie_policy'] === 'true') {
		cookie_policy = true
	}

	const cookies = document.cookie.split(';')
	cookies.forEach(cookie => {
		if(cookie.search(/^params/) === -1) {
			cookie = cookie.replace(/^ +/, '') //
			cookie = cookie.replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`)
			document.cookie = cookie
		}
	})

	// TODO: Костыль до момента реализации быстрой оплаты через БД

	if(cookie_policy === true) {
		let UTCDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
		document.cookie = `cookie_policy=true; path=/; expires=${UTCDate};`;
	}
}

// модалка об использовании cookies
$("#cookieIGree").on("click", function() {
	let UTCDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toUTCString();
    document.cookie = `cookie_policy=true; path=/; expires=${UTCDate};`;
    $(".cookie-modal").remove();
});

$('.js-active-touch-docs').on({
	click: function () {
		localStorage.setItem('showTouchDocs', '1');
	}
})

function showTouchDocs() {// TODO: фикс для того чтобы не отрубало js
	$(window).on('load', function () {
		if(localStorage.getItem('showTouchDocs') === '1') {
			$('#doc2').addClass('active-button').removeClass('inactive-button')
			$('#doc1').addClass('inactive-button').removeClass('active-button')
			$('#touchfin').show()
			$('#gillion').hide()
			localStorage.clear()
		}
	})
}

$('.banner-mobile, .banner-desktop').on('click', function() {
	$('input[name="on-lending"]').val(true)
})
